import React, {useEffect, useState} from 'react';
import {
    DEFAULT_PAGE,
    DEFAULT_PAGE_SIZE,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY,
    ResponseCode
} from "@app/constants/Common";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestCandidates} from "@app/services/CandidateService";
import {
    requestMoveCandidatesToTab,
    requestRemoveCandidatesOutTabs,
    requestSendEmailInviteJob,
    requestStartRunJob,
    requestUpdateCandidatesInSendMails
} from "@app/services/JobService";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";
import {doExportExcel} from "@app/utils/CommonUtils";
import {requestSaveJobPipeline} from "@app/services/JobPipelineService";
import {processRequestCheckDVTJCUVEmailBrief} from "@pages/dvtjcuv/rundvtjcuv/RunDVUtil";

const RunJobCandidateList = (props) => {
    const [currentTab, setCurrentTab] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [runJobInfo, setRunJobInfo] = useState({});

    const {runJob, parentTab, subTab} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const fetchCandidateList = async (runJobData, pTab, sTab, page, isExportExcel) => {
        const params = {page: page > 0 ? page : DEFAULT_PAGE,
            size: DEFAULT_PAGE_SIZE, order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: {
                // candidate_ids: candidateIds,
                run_job_mode: true,
                run_job_id: runJobData ? runJobData.id : runJobInfo.id,
                parent_tab: pTab ? pTab.id : "",
                sub_tab: sTab ? sTab.id : "",
                embedded_job_id: runJobData.embedded_job_id,
            }
        }

        if (isExportExcel) {
            params.is_export_excel = isExportExcel
        }

        const res = await requestCandidates(params);
        if (isExportExcel) {
            doExportExcel(res.content.candidates)
        }
        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    const onExportExcel = async () => {
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true)
    }

    const onSendEmailInviteJob = async (candidateIds) => {
        let requestData = {run_job_id: runJobInfo.id, candidate_ids: candidateIds, job_id: runJobInfo.job_id}
        await requestSendEmailInviteJob(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const saveInputJobPipeline = async (candidateId, internalProcess) => {
        let requestData = {run_job_id: runJobInfo.id, candidate_id: candidateId,
            job_id: runJobInfo.job_id, internal_process: internalProcess}
        const res = await requestSaveJobPipeline(requestData)
        alertMessage(res.sts_code, false, true)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const updateCandidatesInSendMails = async (candidateIds, isInSendMails) => {
        let requestData = {
            run_job_id: runJobInfo.id,
            candidate_ids: candidateIds,
            parent_tab: parentTab,
            sub_tab: parentTab.id,
            in_send_mails: isInSendMails

        }
        await requestUpdateCandidatesInSendMails(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const removeCandidateOutTabs = async (tabIds, candidateIds) => {
        let requestData = {run_job_id: runJobInfo.id,
            candidate_ids: candidateIds,
            parent_tab: parentTab,
            sub_tabs: tabIds,
        }
        await requestRemoveCandidatesOutTabs(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const moveCandidatesToTab = async (currentTabId, nextTabId, candidateIds) => {
        let requestData = {run_job_id: runJobInfo.id,
            candidate_ids: candidateIds,
            from_parent_tab: parentTab,
            to_parent_tab: parentTab,
            from_sub_tab: currentTabId,
            to_sub_tab: nextTabId,
        }
        await requestMoveCandidatesToTab(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const onNextPage = async (page, searchOrderBy) => {
        await fetchCandidateList(runJobInfo, parentTab, subTab, page)
    }

    const onEmbeddedIntoJob = async (jobId) => {
        runJobInfo.embedded_job_id = jobId
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (subTab) {
            setCurrentTab({...subTab})
        }
        if (runJob) {
            setRunJobInfo({...runJob})
            fetchCandidateList(runJob, parentTab, subTab).then()
        }

    }, [runJob, parentTab, subTab]);

    const reMailInviteJob = async (candidateIds, internalProcess) => {
        const res = await requestStartRunJob({candidate_ids: candidateIds, job_id: runJobInfo.job_id, internal_process: internalProcess});

        if (res.sts_code !== ResponseCode.SUCCESS) {
            alertMessage(res.sts_code, false, true)
        } else {
            const newUpdateRunJob = res.content
            setRunJobInfo({...newUpdateRunJob})
            // setMailTabData({...newUpdateRunJob[parentTab.id]})
            fetchCandidateList(newUpdateRunJob, parentTab, subTab).then()
            showMessage(Messages.processSuccess, false, true)
        }
    }

    const onStartCheckSendBriefEmailDVTJCUV = async (condition = {}) => {
        condition.receiver_ids = condition.receiver_ids || []
        const result = await processRequestCheckDVTJCUVEmailBrief(condition)
        if (result) {
            // onChangeTab(DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB)
            fetchCandidateList(runJob, parentTab, subTab)
        }
    }

    return (
        <>
            <CandidateListTable candidates={candidates}
                                allCandidateIds={allCandidateIds}
                                totalCount={totalCount}
                                showBtnSelect
                                onExportExcel={onExportExcel}
                                onSendEmailInviteJob={onSendEmailInviteJob}
                                onSendBriefEmailDVTJCUV={onStartCheckSendBriefEmailDVTJCUV}
                                saveInputJobPipeline={saveInputJobPipeline}
                                mode={CandidateListMode.EMAIL_INVITE_JOB}
                                parentTab={parentTab}
                                subTab={subTab}
                                mailInviteJobTab={currentTab}
                                updateCandidatesInSendMails={updateCandidatesInSendMails}
                                removeCandidateOutTabs={removeCandidateOutTabs}
                                moveCandidatesToTab={moveCandidatesToTab}
                                onEmbeddedIntoJob={onEmbeddedIntoJob}
                                onReMailInviteJob={(candidateIds, internalProcess) => reMailInviteJob(candidateIds, internalProcess)}
                                onSearchCandidates={(page, searchOrderBy) => onNextPage(page, searchOrderBy)}
            />
        </>
    )
}

export default RunJobCandidateList;
